import { render, staticRenderFns } from "./PriceOfferPage.vue?vue&type=template&id=073fc26e"
import script from "./PriceOfferPage.vue?vue&type=script&lang=js"
export * from "./PriceOfferPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports